import PropTypes from "prop-types";
import { brand } from "brand/theme";

// ==============================|| LOGO MAIN (wide wordmark) ||============================== //

export default function LogoMain({
  dark = false,
  height = 36,
  maxWidth = 168,
}) {
  return (
    <img
      src={brand.logoUrl}
      alt={brand.name}
      style={{
        height,
        width: "auto",
        maxWidth,
        display: "block",
        // Wordmark is dark; invert when used on dark chrome
        filter: dark && brand.invertOnDark !== false ? "brightness(0) invert(1)" : "none",
      }}
    />
  );
}

LogoMain.propTypes = {
  dark: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
